import { useParams } from 'react-router-dom';
import { DataTableActions } from 'src/components/DataTable';
import { useModal } from 'src/hooks';
import { isModalComplete } from 'src/components/ModalDialog';
import { useStoreUnitActions } from 'src/redux/helpers';
import solutionsStore from '../../redux';
import { useSolutionUserRoles } from '../../hooks';
import SolutionAdxTableEditContainer from './SolutionAdxTableEditContainer';
import { SolutionAdxTablesItem } from '../../types';

type Props = {
  item?: SolutionAdxTablesItem;
};

function SolutionAdxTableAction({ item }: Props) {
  const { solutionId } = useParams();
  const { isSolutionEditor } = useSolutionUserRoles(solutionId);
  const onClose = (reason) => isModalComplete(reason);

  const [editDialog, showEditDialog] = useModal(SolutionAdxTableEditContainer, {
    item,
    onClose,
  });

  return (
    <DataTableActions
      canEdit={isSolutionEditor}
      onEdit={showEditDialog}
      showDelete={false}
    >
      {editDialog}
    </DataTableActions>
  );
}

export default SolutionAdxTableAction;
